import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import { useTranslation } from "@i18n";
import Input from "../Input/Input";
import stl from "./RangeSliderWithInputs.module.css";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import "./rc-slider.css";
import { useLang } from "@/common/Contexts/LanguageContext";
var RangeSliderWithInputs = function RangeSliderWithInputs(_ref) {
  var _ref$minValue = _ref.minValue,
    DEFAULT_MIN_VAL = _ref$minValue === void 0 ? 0 : _ref$minValue,
    _ref$maxValue = _ref.maxValue,
    DEFAULT_MAX_VAL = _ref$maxValue === void 0 ? 100 : _ref$maxValue,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 10 : _ref$step,
    selectedValue = _ref.selectedValue,
    handleFilterChange = _ref.handleFilterChange,
    filter = _ref.filter;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var lang = useLang();
  var isYearFilter = (filter === null || filter === void 0 ? void 0 : filter.filterField) === "year";
  var _useState = useState(selectedValue),
    rangeValue = _useState[0],
    setRangeValue = _useState[1];
  var _useState2 = useState(selectedValue),
    sliderRangeValue = _useState2[0],
    setSliderRangeValue = _useState2[1];
  var handleMinChange = function handleMinChange(e) {
    var value = e.target.value;
    var xval = Number(value.replace(/,/g, ""));
    var _rangeValue = _slicedToArray(rangeValue, 2),
      _ = _rangeValue[0],
      currentMax = _rangeValue[1];
    if (value.toString().length === 0 || isNaN(xval)) {
      return setRangeValue(function (pre) {
        var newVal = _toConsumableArray(pre);
        newVal[0] = '';
        return newVal;
      });
    }
    var isGreaterThanMax = xval > currentMax;
    var isWithinValidRange = xval && xval >= DEFAULT_MIN_VAL && !isGreaterThanMax;
    if (isWithinValidRange) {
      setRangeValue(function (pre) {
        var newVal = _toConsumableArray(pre);
        newVal[0] = xval;
        return newVal;
      });
      setSliderRangeValue(function (pre) {
        var newVal = _toConsumableArray(pre);
        newVal[0] = xval;
        return newVal;
      });
    } else {
      return setRangeValue(function (pre) {
        var newVal = _toConsumableArray(pre);
        newVal[0] = xval;
        return newVal;
      });
    }
  };
  var handleOnBlurMin = function handleOnBlurMin(e) {
    var _rangeValue2 = _slicedToArray(rangeValue, 2),
      xval = _rangeValue2[0],
      currentMax = _rangeValue2[1];
    if (xval > currentMax || xval < DEFAULT_MIN_VAL) {
      setRangeValue(function (pre) {
        var newVal = _toConsumableArray(pre);
        newVal[0] = DEFAULT_MIN_VAL;
        return newVal;
      });
      setSliderRangeValue(function (pre) {
        var newVal = _toConsumableArray(pre);
        newVal[0] = DEFAULT_MIN_VAL;
        return newVal;
      });
    }
  };
  var handleMaxChange = function handleMaxChange(e) {
    var value = e.target.value;
    var xval = Number(value.replace(/,/g, ""));
    var _rangeValue3 = _slicedToArray(rangeValue, 2),
      currentMin = _rangeValue3[0],
      _ = _rangeValue3[1];
    if (value.toString().length === 0 || isNaN(xval)) {
      return setRangeValue(function (pre) {
        var newVal = _toConsumableArray(pre);
        newVal[1] = '';
        return newVal;
      });
    }
    var isLessThanMin = xval < currentMin;
    var isWithinValidRange = xval <= DEFAULT_MAX_VAL && !isLessThanMin;
    if (isWithinValidRange) {
      setRangeValue(function (pre) {
        var newVal = _toConsumableArray(pre);
        newVal[1] = xval;
        return newVal;
      });
      setSliderRangeValue(function (pre) {
        var newVal = _toConsumableArray(pre);
        newVal[1] = xval;
        return newVal;
      });
    } else {
      return setRangeValue(function (pre) {
        var newVal = _toConsumableArray(pre);
        newVal[1] = xval;
        return newVal;
      });
    }
  };
  var handleOnBlurMax = function handleOnBlurMax(e) {
    var _rangeValue4 = _slicedToArray(rangeValue, 2),
      currentMin = _rangeValue4[0],
      xval = _rangeValue4[1];
    // should not reset to default in case maxValue is equal to current minValue
    if (xval < currentMin || xval >= DEFAULT_MAX_VAL) {
      // Adjusted condition

      setRangeValue(function (pre) {
        var newVal = _toConsumableArray(pre);
        newVal[1] = DEFAULT_MAX_VAL;
        return newVal;
      });
      setSliderRangeValue(function (pre) {
        var newVal = _toConsumableArray(pre);
        newVal[1] = DEFAULT_MAX_VAL;
        return newVal;
      });
    }
  };
  var createNiceNumbers = function createNiceNumbers(value) {
    var stringifiedValue = value.toString();
    if (!stringifiedValue) return stringifiedValue;
    return parseInt(stringifiedValue.replace(/,/g, "")).toLocaleString();
  };
  useEffect(function () {
    handleFilterChange(filter, {
      min: sliderRangeValue[0],
      max: sliderRangeValue[1]
    });
  }, [sliderRangeValue]);
  return /*#__PURE__*/React.createElement("div", {
    className: stl.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.inputsWrapper
  }, /*#__PURE__*/React.createElement(Input, {
    autoComplete: "off",
    type: "text",
    name: "min",
    value: isYearFilter ? rangeValue[0] : createNiceNumbers(rangeValue[0]),
    onChange: handleMinChange,
    onBlur: handleOnBlurMin,
    label: t("from", {
      ns: "web_search"
    })
  }), /*#__PURE__*/React.createElement(Input, {
    autoComplete: "off",
    type: "text",
    name: "max",
    value: isYearFilter ? rangeValue[1] : createNiceNumbers(rangeValue[1]),
    onChange: handleMaxChange,
    onBlur: handleOnBlurMax,
    label: t("to", {
      ns: "web_search"
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.sliderWrapper
  }, /*#__PURE__*/React.createElement(Slider, {
    reverse: lang === "ar",
    range: true,
    min: DEFAULT_MIN_VAL,
    max: DEFAULT_MAX_VAL,
    allowCross: false,
    defaultValue: [DEFAULT_MAX_VAL, DEFAULT_MIN_VAL],
    step: step,
    value: sliderRangeValue,
    onChange: function onChange(value) {
      setSliderRangeValue(value);
      setRangeValue(value);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.valuesWrapper
  }, /*#__PURE__*/React.createElement("strong", null, isYearFilter ? sliderRangeValue[0] : createNiceNumbers(sliderRangeValue[0])), /*#__PURE__*/React.createElement("strong", null, isYearFilter ? sliderRangeValue[1] : createNiceNumbers(sliderRangeValue[1]))));
};
export default RangeSliderWithInputs;